import React, { memo } from 'react';
import block from 'bem-cn';

import SVG from 'components/SVG';
import approveSVG from 'shared/img/check-sircle.svg';
import declineSVG from 'shared/img/cross-sircle.svg';

import './PasswordComplexityStatus.scss';

const b = block('password-complexity-status');

const bars = [0, 1, 2];

const PasswordComplexityStatus = ({ requirements, activeBarsCount, activeColor }) => (
  <div className={b()}>
    <div className={b('bars')}>
      {bars.map(bar => (
        <span
          key={bar}
          className={b('bar', { active: bar < activeBarsCount })}
          style={bar < activeBarsCount ? { backgroundColor: activeColor } : undefined}
        />
      ))}
    </div>

    <div className={b('list')}>
      {requirements.map(requirement => (
        <div key={requirement.id} className={b('item', { valid: requirement.isValid })}>
          <SVG
            svgProps={{ svg: requirement.isValid ? approveSVG : declineSVG }}
            containerClassName={b('icon').toString()}
          />
          <span>{requirement.label}</span>
        </div>
      ))}
    </div>
  </div>
);

export default memo(PasswordComplexityStatus);